import { useMemo, useRef } from 'react';
import { Editor } from '@tiptap/react';

import * as Styled from './richtext.style';
import { useToolbarJump } from './richtext.hooks';
import RichtextInlineToolbar from './richtext-inline-toolbar';
import { InputDescriptionStyled } from 'approot/shared/styles/inputs.style';

type Props = {
  editor: Editor;
  className?: string;
  characterLimit?: number;
  minHeight?: number;
  excludeTools?: boolean;
};
const RichtextInline = ({
  editor,
  className,
  characterLimit,
  minHeight,
  excludeTools,
}: Props) => {
  const toolbarRef = useRef<HTMLDivElement | null>(null);

  useToolbarJump(toolbarRef);

  const includesCharacterCount = useMemo(
    () =>
      editor.extensionManager.extensions.some(
        extension => extension.name === 'characterCount'
      ),
    [editor.extensionManager.extensions]
  );

  return (
    <>
      <Styled.RichtextInlineEditor
        $minHeight={minHeight}
        $excludeTools={excludeTools}
        editor={editor}
        className={className}
        data-selector="rich-text-inline-editor"
      >
        <RichtextInlineToolbar
          ref={toolbarRef}
          editor={editor}
          data-selector="txt-editor-tools"
        />
      </Styled.RichtextInlineEditor>
      {includesCharacterCount && (
        <InputDescriptionStyled textAlign="right">
          {editor.storage.characterCount.characters()} / {characterLimit}{' '}
          characters
        </InputDescriptionStyled>
      )}
    </>
  );
};

export default RichtextInline;
